import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const ModalFamily = styled(Modal)`
  footer {
    position: sticky;
    bottom: 0;
    background: #fff;
    display: flex;
    justify-content: space-around;
    padding: 0.4rem;
    border-radius: 5px;
    border: 1px solid #ddd;
    margin-top: 0.5rem;

    button {
      background: #6e8aad;
      color: white;
      padding: 0.5rem 1rem;
      border: none;
      border-radius: 5px;
      transition: background 0.3s;
      font-size: 10px !important;
      font-weight: bold;


      &:hover {
        background: #3567a3;
      }
    }
  }

`;

export const Container = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem 2rem;
  font-family: Arial, sans-serif;
  
  h2 {
    font-size: 22px;
    margin-bottom: 1rem;
  }
`;

export const Wrapper = styled.div`
  .wrapper-select {
    display: flex;
    gap: 1rem;
    align-items: center;

    button {
      border: none;
      background-color: #aaaebd;
      font-size:11px !important;
      height: 25px;
      padding: 0 1rem;
      border-radius: 5px;
      margin-bottom: 2px;
      color: white;
    }
  }

  .select-auto {

    .select {
      width: 250px;
    }
  }
`



